import { ensureProtocol } from '../../../utils/string';
import './LinkPreviewCard.css';

interface LinkPreviewCardProps {
  url: string;
  title?: string;
  description?: string;
  imageSources?: string;
}

export const LinkPreviewCard = (props: LinkPreviewCardProps) => {
  const { title, url, description, imageSources } = props;

  return (
    <a
      className="link-preview"
      href={ensureProtocol(url)}
      target="_blank"
      rel="noopener noreferrer"
    >
      {imageSources && <img src={imageSources} alt="Preview" />}
      <div className="link-info">
        <label className="text-xs text-gray-600">{url}</label>
        <p className="text-lg font-bold text-cyan-800">{title}</p>
        {description && !description.includes('LPLinkMetadata') ? (
          <p className="text-sm text-gray-600">{description}</p>
        ) : null}
      </div>
    </a>
  );
};
